import * as React from "react";
import Special from "../../_data/models/Special";
import Meta from "../../_data/models/Meta";
import {SpecialsRoutes} from "../../routes";
import {formatDate} from "../../_helpers/utils";
import {Link} from "react-router-dom";
import ReduxInfiniteScroll from "redux-infinite-scroll";
import {OrderedMap} from "immutable";

interface Props {
    items: OrderedMap<number, Special>;
    meta: Meta;
    loading: boolean;
    viewSpecials: (specialType: string) => void;
    currentPath: string;
    loadMore: (meta: Meta, currentPath: string) => void;
}

const handleOnClickViewSpecials = (specialsTab: string, props: Props) => {
    props.viewSpecials(specialsTab);
}

const SpecialsComponent = (specialComponentProps: Props) => {
    let {items, currentPath, loading, loadMore, meta} = specialComponentProps;
    let specialsList;

    return (
        <div className="row">
            <div className="large-12 columns">
                <ul className="tabs expanded mt-2" data-tabs id="users">
                    <li className="tabs-title text-center"
                        onClick={(e) => handleOnClickViewSpecials(null, specialComponentProps)}><Link
                        to={SpecialsRoutes.index()}
                        aria-selected={(currentPath == SpecialsRoutes.index() ? 'true' : 'false')}>My Specials</Link>
                    </li>
                    <li className="tabs-title text-center"
                        onClick={(e) => handleOnClickViewSpecials('liked', specialComponentProps)}><a href="#"
                                                                                                      aria-selected={(currentPath == SpecialsRoutes.tab('liked') ? 'true' : 'false')}>Liked
                        Specials</a></li>
                    <li className="tabs-title text-center"
                        onClick={(e) => handleOnClickViewSpecials('expired', specialComponentProps)}><a href="#"
                                                                                                        aria-selected={(currentPath == SpecialsRoutes.tab('expired') ? 'true' : 'false')}>Expired</a>
                    </li>
                </ul>
                <div className="tabs-content" data-tabs-content="users">
                    {specialsList}
                    <ReduxInfiniteScroll
                        holderType="ul"
                        className="list-block flex-container"
                        loadMore={() => loadMore(meta, currentPath)}
                        elementIsScrollable={false}
                        loadingMore={loading}
                        showLoader={false}
                        threshold={100}>
                        {
                            items.toArray().map((item) => {
                                return (
                                    <li key={item.id}>
                                        <div className="media-object">
                                            <div className="media-object-section flushed middle">
                                                <div className="img-wrapper small">
                                                    <img src={item.user.profilePicture()}/>
                                                </div>
                                            </div>
                                            <div className="media-object-section middle">
                                                <div className="text-group">
                                                    <p><b>{item.title}</b></p>
                                                    <p className="subheader">
                                                        <small>{item.prettyEndDateString()}</small>
                                                    </p>
                                                    <p className="subheader">
                                                        <small><i
                                                            className="fa fa-heart"/> &nbsp; {item.likeCount > 1 ? item.likeCount + ' Likes' : item.likeCount + ' Like' }
                                                        </small>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <Link to={SpecialsRoutes.view(item.id)} className="button primary pull-right">
                                            <i className="fa fa-eye-o"/>&nbsp; View Special
                                        </Link>
                                    </li>
                                )
                            })
                        }
                    </ReduxInfiniteScroll>
                </div>
            </div>
        </div>
    );
};

export default SpecialsComponent;


// WEBPACK FOOTER //
// ./app/client/special/components/SpecialsComponent.tsx